import {Component, Input, OnInit} from '@angular/core';
import {Events} from "../../../../../framework/providers/events";
import {ItemProvider} from "../../providers/item-provider/item-provider.service";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";
import {Item} from "../../../../../framework/model/core/items/item";

@Component({
    selector: 'app-item-agent-tool',
    templateUrl: './item-agent-tool.component.html',
    styleUrls: ['./item-agent-tool.component.scss'],
})
export class ItemAgentToolComponent implements OnInit {

    @Input()
    public model: Item;

    @Input()
    public agentToolData;

    @Input()
    public cartItem;

    @Input()
    public options;

    public sub_prefix: string = 'sub_' + Math.floor(Math.random() * Math.floor(1000000));

    constructor(public events: Events, public itemProvider: ItemProvider, public modelTools: ModelToolsProvider) {
    }

    ngOnInit() {
        this.events.subscribe(this.model.data.id+'_agentToolbarFieldChanged', (params) => {
               this.agentToolChanged(params['field'])
        }, this.sub_prefix);
    }

    ngOnDestroy()
    {
        this.events.unsubscribe(this.model.data.id+'_agentToolbarFieldChanged',  this.sub_prefix);
    }

    agentToolChanged(field=null) {


        let cartItem = this.cartItem;
        let model = this.model;
        let agentToolData = this.agentToolData;

        if(agentToolData['data'][field]['value'] === null)
        {
            return
        }

        if(['amount', 'price'].includes(field) && cartItem[field] == agentToolData['data'][field]['value']){
            return;
        }

        let data_fields = ['comments', 'coupon_amount', 'coupon_code', 'discount']
        if(data_fields.includes(field) && cartItem['data'][field] == agentToolData['data'][field]['value']){
            return;
        }

        if(!agentToolData['data'][field]['input']){
            return;
        }

        // console.log("CHANGEDDDDDD!!!", field, agentToolData['data']['price']['value'], agentToolData['data'][field]['input'])

        let data = cartItem['data'];
        for(let f in data_fields){
            data[data_fields[f]] = agentToolData['data'][data_fields[f]]['value'];
        }


        let amount = agentToolData['data']['amount']['value'] && ('' + agentToolData['data']['amount']['value'].length) ? parseFloat(agentToolData['data']['amount']['value']) : 0;

        agentToolData['data']['amount']['value'] = amount;

        let price = parseFloat(agentToolData['data']['price']['value']);

        let index = cartItem['index'] ? cartItem['index'] : model.data.id;

        // setTimeout(function () {

        // field == 'price' && model.data.basePrice && agentToolData['data'][field]['value'] < model.data.basePrice



        agentToolData['cart_prefix'] = data['cart_prefix'] = 'item_' + Math.floor(Math.random() * Math.floor(1000000));

        data['price_error'] = price < model.data.basePrice;

        clearInterval(this.agentToolData['interval']);
        let me = this;
        this.agentToolData['interval'] = setInterval(function () {
            console.log('section tool interval')
            clearInterval(me.agentToolData['interval']);

            if (!price) return;

            if (!amount) {
                if (!cartItem['amount']) return;
                me.itemProvider.removeCartItemFromCart(cartItem)

            } else {
                console.log('Add to cart', price)
                me.itemProvider.addToCart(model, amount, false, false, false, cartItem['props'],
                    null, null, price, false, index, false, price, 0, data, {'agentToolbar': true});
            }
            me.agentToolData['loading'] = true;
        }, 1500)

    }


    getFieldOptions(field) {
        if (field != 'discount') return;
        let key = 'agentDiscounts';
        let discount_options = this.agentToolData['data'][field]['options']
        this.modelTools.getKey(key).then((res: Array<number>) => {
            console.log(res)

            if (!res) return;
            discount_options.length = 0;

            for (let k of res) {
                discount_options.push(k)
            }

        });
    }

    setEditField(field, closeToolbar = false) {
        if (!this.agentToolData['data'][field]['input'] || this.agentToolData['data'][field]['select'] || closeToolbar) {
            this.events.publish('closeItemToolbar');
            this.agentToolData['active'] = null;
            return;
        }
        let index = this.cartItem ? this.cartItem['index'] : this.model.data.id;
        this.itemProvider.showItemToolbar(this.model, index, field, true, this.agentToolData);
        this.agentToolData['active'] = field;

        // if (this.businessService.getScreenSize()[0] > 1400) {
        //     console.log(this.businessService.getScreenSize()[0])
        //     return
        // }
        //
        // let data = this.agentToolData['data'][field];
        // let prefix = 'editField' + Math.floor(Math.random() * Math.floor(1000000));
        // this.events.publish('viewEditFieldToolbar', {'data': data, 'prefix': prefix, 'currencyCode':this.model.data.currencyCode});
        // // data['active'] = true;
        // this.agentToolData['active_field'] = field;
        // this.events.subscribe(prefix, (close) => {
        //     // console.log(data['value'], value);
        //     // data['value'] = value;
        //     // data['active'] = false;
        //     if (close)
        //         this.agentToolData['active_field'] = null;
        //
        //     this.agentToolChanged();
        // })
    }

    fieldFocus(field)
    {
        if(['comments'].includes(field))
        {
            return
        }

        if(!this.agentToolData['data'][field]['focus']) {
            this.agentToolData['data'][field]['placeholder'] = this.agentToolData['data'][field]['value'];
            this.agentToolData['data'][field]['value'] = null;
        }
        this.agentToolData['data'][field]['focus'] = true;
    }

    fieldUnFocus(field) {
        let me = this;
        setTimeout(function () {
            me.agentToolData['data'][field]['focus'] = false;

            if(me.agentToolData['data'][field]['value'] === null && me.agentToolData['data'][field]['placeholder'])
                me.agentToolData['data'][field]['value'] = me.agentToolData['data'][field]['placeholder']
        }, 100)
    }

    addToValue(field, value)
    {
        let field_value = parseFloat(this.agentToolData['data'][field]['value'])
        field_value += value
        if(field_value < 0) return;
        this.agentToolData['data'][field]['value'] = field_value;
    }

}
